<div>
  <router-outlet></router-outlet>
  <app-responsive-helper></app-responsive-helper>
  <!-- Idle warning dialog -->
  <app-idle-warning></app-idle-warning>
</div>
